import { useAuth0 } from "@auth0/auth0-react";
import { getUserIdFromToken } from "common";
import { useEffect, useState } from "react";
export function getUserIdFromAccessToken(token) {
    return token ? getUserIdFromToken(token) : null;
}
export default function useAuth() {
    const { getAccessTokenSilently, loginWithRedirect, isAuthenticated, isLoading, logout, error: auth0Error, } = useAuth0();
    const [error, setError] = useState(null);
    const [userAuth, setUserAuth] = useState({
        userId: null,
        userToken: null,
    });
    useEffect(() => {
        async function getAuth() {
            if (isLoading)
                return;
            if (!isAuthenticated) {
                await loginWithRedirect({
                    appState: { returnTo: window.location.pathname },
                });
                return;
            }
            try {
                const accessToken = await getAccessTokenSilently();
                const userIdFromToken = getUserIdFromAccessToken(accessToken);
                setUserAuth({
                    userToken: accessToken,
                    userId: userIdFromToken,
                });
            }
            catch (_error) {
                if (_error instanceof Error) {
                    // eslint-disable-next-line no-console
                    console.error((_error === null || _error === void 0 ? void 0 : _error.message) || "Error accessing user's token");
                    setError(_error);
                }
            }
        }
        getAuth();
    }, [isAuthenticated, isLoading, getAccessTokenSilently, loginWithRedirect]);
    return {
        user: userAuth,
        logout,
        isLoading,
        isAuthenticated,
        error: error || auth0Error,
    };
}
//# sourceMappingURL=index.js.map